import { MATCH_LIST_QUERY_KEY, matchQueryOptions } from "@/features/matches";
import type { RealtimeHandler } from "@/shared/realtime";

import { analysesSummaryQueryOptions } from "../api/analysesSummaryQueryOptions";
import { analysisQueryOptions } from "../api/analysisQueryOptions";
import { analysisUsageQueryOptions } from "../api/analysisUsageQueryOptions";

// `analysis.done` → находок в событии нет, разбор, матч, список матчей, сводка разборов
// и счётчик разборов перечитываются через REST.
// Повтор события — ещё одна инвалидация, данные те же.
export const handleAnalysisDone: RealtimeHandler<"analysis.done"> = (event, { queryClient }) => {
  void queryClient.invalidateQueries({
    queryKey: analysisQueryOptions(event.analysis_id).queryKey,
  });
  void queryClient.invalidateQueries({ queryKey: matchQueryOptions(event.match_id).queryKey });
  void queryClient.invalidateQueries({ queryKey: MATCH_LIST_QUERY_KEY });
  void queryClient.invalidateQueries({ queryKey: analysesSummaryQueryOptions().queryKey });
  void queryClient.invalidateQueries({ queryKey: analysisUsageQueryOptions().queryKey });
};
